<template>

  <div class="flex flex-row  ">
    <el-input-number
      v-model="inicio"
      :controls="false"
      :max="anoMax"
      size="4"
      @input="(currentValue ,oldValue)=> {
           this.$emit('update:inicio', currentValue );
           this.$emit('update:fim', currentValue );
           this.fim = currentValue;
      }"
    ></el-input-number>
    <div class="p-2">/</div>
    <el-input-number
      @input="$emit('update:fim', $event )"
      v-model="fim"
      :controls="false"
      :max="inicio + 1"
      :min="inicio"
    ></el-input-number>
  </div>
</template>

<script>

export default {
  data() {
    const anoAtual = (new Date()).getFullYear();
    return {
      inicio: anoAtual,
      fim: anoAtual,
      anoMax: anoAtual
    }
  }
}
</script>

<style scoped>
</style>
